import { Input, InputProps } from "@ezmid/components-library";
import {
  FieldError,
  Controller,
  FieldValues,
  Control,
  Path,
  RegisterOptions,
} from "react-hook-form";

interface SharedInputProps<T extends FieldValues>
  extends Omit<InputProps, "ref" | "onChange"> {
  control: Control<T>;
  name: Path<T>;
  rules?: RegisterOptions<T>;
  label?: string;
  id: string;
  error?: FieldError | any;
  htmlFor?: string;
  defaultValue?: any;
}
export function FormInputField<T extends FieldValues>({
  type,
  error,
  isDisabled = false,
  control,
  name,
  rules,
  label,
  htmlFor,
  defaultValue,
  ...rest
}: SharedInputProps<T>) {
  return (
    <div>
      <label
        htmlFor={htmlFor}
        className="block font-normal tmb-1 text-gray-500"
      >
        {label}
      </label>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Input
              type={type}
              ref={ref}
              onChange={onChange}
              value={value}
              isInvalid={!!error}
              errorMessage={error?.message}
              {...rest}
            />
          );
        }}
      />
    </div>
  );
}
